import type { ComponentSize } from '../../utility';

export const BUTTON_SIZE_CLASSES: Record<ComponentSize, string> = {
  32: 'tw-button-32',
  36: 'tw-button-36',
  44: 'tw-button-44',
};
